<template>
	<el-row class="maintwobox">
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list">
				<img src="@/assets/image/home/casepic1.png">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">INSTALLATION OF THE GUIDING SYSTEMFOR BLIND IN CHINA
					</el-row>
					<el-row class="mainOnebox_main_list_name2">HGH AIRPORT,HZ CHN</el-row>
					<el-row class="mainOnebox_main_list_name3">
						<span>Hezone was contracted by SHQJ Construction for the recently completed Hangzhou
							International Airportdevelopment project . The project unites two buildings in the airport
							area the old airport area and new terminal area</span> <br><br>
						<span>Hezone's renowned elegant and compliant products made it the obvious choice to compliment
							the projectsremarkable design and particular hues . To achieve this , Hezone supplied and
							installed approximately 25 squaremetres of their 316L Stainless Steel T achiles across the
							site at various locations such as stair landings and thebase of escalators . This product
							has been tested by SGS Lab to achieve an R12 slip resistance rating , givingthe builder
							peace-of-mind</span> <br><br>
						<span>If you have any questions in relation to the Hezone range , Hezone is ready and able to
							assist you in getting it rightWe can help interpret and apply the relevant standards and
							codes and design , manufacture and install solutions toyour project requirements</span>
						<br><br>
					</el-row>
				</el-row>
			</div>
			<div class="mainOnebox_main_list">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">HIGH-END VILLAS ANTI-SKIDDING SYSTEMREDEVELOPMENT PROJECT
						IN CHINA</el-row>
					<el-row class="mainOnebox_main_list_name2">HANGZHOU,ZHEJIANG,CHN</el-row>
					<el-row class="mainOnebox_main_list_name3">
						<span>KSP Villa area is a part located in Hangzhou between the inner-city business district and
							the Qiantang Riverhis project required a standard application of Waming tactile indicators
							to the top and bootom of the main stair .Hezone was chosen to supply and install the
							HZ-T1114H 316L stainless steel classic waming tactile</span> <br><br>
					</el-row>
				</el-row>
				<img src="@/assets/image/home/casepic2.png">
			</div>
			<div class="mainOnebox_main_list">
				<img src="@/assets/image/home/casepic3.png">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">SHA VOLKSWAGEN AUTO CO ., LTD FRPGRATING INSTALLATION
						PROJECT</el-row>
					<el-row class="mainOnebox_main_list_name2">HANGZHOU,ZHEJIANG,CHN</el-row>
					<el-row class="mainOnebox_main_list_name3">
						<span>Hezone supplied and installed FRP gritted gratings and PVC anti-slip door mat to the SHA
							Volkswagen Atuo CoLtd in Peking , China</span> <br><br>
						<span>Hezone was chosen to supply and install the HZ-G1358 FRP classic gned gratings and
							HZ-G9656 Nylon anti-slipmat . They are facilitated better access to all persons , not just
							the visually impaired</span> <br><br>
					</el-row>
				</el-row>
			</div>
			<div class="mainOnebox_main_list">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">STAIR NOSING SYSTEM INSTALLATIONFOR EVOLUTION TOWER
					</el-row>
					<el-row class="mainOnebox_main_list_name2">MOSCO,RU</el-row>
					<el-row class="mainOnebox_main_list_name3">
						<span>When it comes to the design , supply and installation of tactile indicators , stair treads
							and edging , Hezone IndustryTech Co , Ltd has been the trusted name in the industry for more
							than 12 years</span> <br><br>
						<span>Hezone pioneered the architectural anti-skidding tactile industry in China , Hezone's work
							can be seen throughouta number of iconic sites across the world , including Stockholm
							Walking Street , Frankfurt Central Park , HawthornTown Hall , Pattaya Shopping Mall , Siam
							Mall , Madrd El Corte Ingles . Among the companys latest projects wasthe Evolution Tower ,
							where it installed a variety of tactile in various parts of the site</span> <br><br>
						<span>Hezone started the project in Oct , with the majority of works completed from the 5th ,
							Oct . until the project was finished in early Dec . The site works were completed by
							10staffs who were supported by the Hezone after-service team .</span> <br><br>
						<span>With 15 staffs as well as contracted installers , Hezone's specialist knowledge , combined
							with its focus on detail and quality , sees it continually chosen for tactile , stair and
							treaedging compliance requirements on both large and smaller construction projects . In
							addition , all of our installers complete an 18-step accreditation process before going
							onsite . This means our clients can be assured that our contractors have the experience and
							expertise when it comes to the compliance of tactile and edging installation , as wellas the
							aesthetics</span> <br><br>
					</el-row>
				</el-row>
				<img src="@/assets/image/home/casepic4.png">
			</div>

		</el-row>
	</el-row>
</template>

<script>
	// import banner from './components/banner.vue';

	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {

			}
		},
		methods: {

		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.maintwobox {
		background: url(../../../assets/image/home/home_bg2.jpg);
		padding-top: 5.2vw;

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: space-around;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 100%;
				height: auto;
				margin: 1vh 1.5vw;
				border-radius: 5px;
				overflow: hidden;
				display: flex;
				text-align: left;
				margin-top: 160/@vw;
				img {
					width: 19.8vw;
					height: 14.8vw;
					border-radius: 1vw;
					margin-left: 3vw;
				}

				.mainOnebox_main_list_name1 {
					max-width: 790px;
					font-weight: 700;
					color: #b28847;
					font-size: 32/@vw;
					padding-left: 30/@vw;
					box-sizing: border-box;
				}

				.mainOnebox_main_list_name2 {
					max-width: 790px;
					font-weight: 700;
					color: #66563d;
					font-size: 24/@vw;
					text-align: left;
					margin-top: 18/@vw;
					padding-left: 30/@vw;
				}

				.mainOnebox_main_list_name3 {
					max-width: 790px;
					margin-top: 30/@vw;
					color: #fafafa;
					font-size: 16/@vw;
					padding-left: 30/@vw;
				}

			}

		}
	}
</style>
